module.exports = __webpack_public_path__ + "img/amp.e6e3be95.svg";